// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modals .modal.trailer[data-v-5802adbb]{width:80%;height:86%;max-width:12rem}.modals .modal.trailer .youtube-wrapper[data-v-5802adbb]{position:relative;width:100%;height:6.75rem}.modals .modal.trailer .youtube-wrapper iframe[data-v-5802adbb]{position:absolute;top:0;left:0;width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
